import React, { useEffect } from "react";
import { useState } from "react";
import { Table, Form } from "react-bootstrap";
import RatingComponent from "../../../../components/Ratingforfeedback";
import HTMLComponent from "../../../../components/HtmlComponent";
import MyEditor from "../../../../components/AddFeedbackCKEditor";
import axios from "axios";
import { Link, useParams } from "react-router-dom";
import RatingInput from "../../../../components/Ratingforfeedback";
import { toast } from "react-toastify";
import { FileUploader } from "../../../../components/FeedbackFileUploader";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import { API_URL } from "../../../../constants/index";
import { FaSpinner } from 'react-icons/fa';
import {
  GetServiceCaller,
  PostServiceCaller,
  PostFormServiceCaller,
} from "../../../../services/serviceCaller";
import { Modal, Button, Alert } from "react-bootstrap";
const AddFeedback = () => {
  const { pageLoading, setPageLoading } = useState(true);
  const [loading, setLoading] = useState(false);
  const { interview_id, feedback_id } = useParams();
  const [skillEvaluationPara, setSkillEvaluationPara] = useState([]);
  const [selectedOption, setSelectedOption] = useState("No");
  const [selectedImage, setSelectedImage] = useState(null);
  const [fileName, setFileName] = useState("");
  const [file, setFile] = useState([]);
  const [submitted, setSubmitted] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [jobDescription, setJobDescription] = useState("");
  const [fileError, setFileError] = useState("");
  const [commentError, setCommentError] = useState([]);
  // const history = useHistory();
  const navigate = useNavigate();
  const basicDetails = {
    JobTitle: "",
    interviewee: "",
    interviewer: "",
  };
  const [basicDetail, setbasicDetail] = useState(basicDetails);

  const initialFormData = {
    JobDescriptionID: "",
    CandidateID: "",
    ScheduleInterviewID: 3765,
    InterviewerID: "",
    InterviewDate: "",
    InterviewTime: "",
    Location: "",
    Round: "",
    Remark: "",
    ResumePath: "",
    ResumeBasePath:"",
    OverallRating: "",
    EligibleNextRound: 0,
    CandiateStatus_181: 1266,
    SuitableForPosition: "No",
    SuitableRemark: "",
    file: [],
    lines: [],
  };
  const [formData, setFormData] = useState(initialFormData);
  useEffect(() => {
    fetchDetails();
  }, []);

  const fetchDetails = async () => {
    //  if (id) {

    try {
      const response = await GetServiceCaller(
        `${API_URL}interviewfeedback?param=${feedback_id}&id=${interview_id}`
      );
      if (response?.data?.status) {
        const details = response?.data?.header;
        const jobtitle = response?.data?.jobtitle.Name;
        const candidate = response?.data?.candidate?.FullName;
        const interviewer = response?.data?.interviewer?.Name;
        setbasicDetail({
          JobTitle: jobtitle || "",
          interviewee: candidate || "",
          interviewer: interviewer || "",
        });

        const tableDate = response?.data?.feedbackcategories;
        setSkillEvaluationPara(tableDate);


        const Lines = [];
        const stripHTML = (html) => {
          const tempDiv = document.createElement("div");
          tempDiv.innerHTML = html;
          return tempDiv.textContent || tempDiv.innerText || "";
        };
        let comment_error = [];
        for (let i = 0; i < tableDate.length; i++) {
          let objPush = {
            GroupCategoryLabel: tableDate[i].text,
            CandidateFeedbackCategory_183: tableDate[i].value,
            OutOfRating: 5,
            Rating: 1,
            Comment: stripHTML(tableDate[i].Comment),
            GroupCategoryDescription: tableDate[i].GroupCategoryDescription,
          };
          Lines.push(objPush);
          comment_error.push("");
        }
        setCommentError(comment_error);
  
        if (details) {
          const {
            ID,
            JobDescriptionID,
            CandidateID,
            InterviewerID,
            ReferralID,
            InterviewDate,
            InterviewTime,
            Location,
            Round,
            Round_name,
            IsFinalRound,
            FeedbackMasterID,
            Remark,
            ResumePath,
            ResumeBasePath,
            IsInActive,
            IntervieweeMailTemplateID,
            InterviewerMailTemplateID,
            SchedularMailTemplateID,
            CreatedBy,
            ModifiedBy,
            CreatedDate,
            ModifiedDate,
            RevisionNumber,
          } = details;

          // Below Section is dedicated to change the format of date coming from backed
          const dateObject = new Date(InterviewDate);
          const day = dateObject.getDate();
          const month = dateObject.getMonth() + 1;
          const year = dateObject.getFullYear();
          const formattedDay = day < 10 ? `0${day}` : day;
          const formattedMonth = month < 10 ? `0${month}` : month;
          const formattedDate = `${formattedDay}-${formattedMonth}-${year}`;

          // Below Section is dedicated to change the format of time coming from backed
          const [hours, minutes] = InterviewTime.split(":");
          let formattedHours = parseInt(hours, 10);
          const amOrPm = formattedHours >= 12 ? "PM" : "AM";
          formattedHours = formattedHours % 12 || 12;
          const formattedTime = `${formattedHours}:${minutes.padStart(2, "0")} ${amOrPm}`;

          setFormData({
            JobDescriptionID: JobDescriptionID || "",
            CandidateID: CandidateID || "",
            ScheduleInterviewID: ID,
            InterviewerID: InterviewerID || "",
            InterviewDate: formattedDate || "",
            InterviewTime: formattedTime || "",
            Location: Location || "",
            Round: Round || "",
            Round_name: Round_name || "",
            Remark: "",
            ResumePath: ResumePath || "Not Available",
            ResumeBasePath: ResumeBasePath || "Not Available",
            OverallRating: "",
            EligibleNextRound: 0,
            CandiateStatus_181: 1266,
            SuitableForPosition: "No",
            SuitableRemark: "",
            lines: Lines,
          });
          setJobDescription(response.data.job_description.Description);
        } else {
          console.error("Job not found with ID:", interview_id);
        }
      } else {
        navigate("/feedback-link-expire");
      }
    } catch (error) {
      console.error("Error fetching job details:", error);
    }
    // }
  };
  const truncateImageName = (name, maxLength) => {
    if (name.length <= maxLength) return name;
    return name.substring(0, maxLength) + "...";
  };
  // const HandleResult = (event) => {
  //   setSelectedOption(event.target.value);

  //   let eligibeleStatus = null;
  //   let CandiateStatus = null;
  //   if (event.target.value.toLowerCase() == "yes") {
  //     eligibeleStatus = 1;
  //     CandiateStatus = 1265;
  //   } else {
  //     eligibeleStatus = 0;
  //     CandiateStatus = 1266;
  //   }
  //   setFormData(prevState => ({
  //     ...prevState,
  //     "SuitableForPosition": event.target.value,
  //     'EligibleNextRound': eligibeleStatus,
  //     'CandiateStatus_181': CandiateStatus
  //   }));

  // };
  const HandleResult = (event) => {
    const value = event.target.value;
    setSelectedOption(value);

    let eligibeleStatus = null;
    let CandiateStatus = null;
    if (value.toLowerCase() === "yes") {
      eligibeleStatus = 1;
      CandiateStatus = 1265;
    } else {
      eligibeleStatus = 0;
      CandiateStatus = 1266;
    }

    setFormData((prevState) => ({
      ...prevState,
      SuitableForPosition: value,
      EligibleNextRound: eligibeleStatus,
      CandiateStatus_181: CandiateStatus,
    }));
  };
  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setSelectedImage(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleRatingChange = (rowIndex, ratingValue) => {

    formData.lines[rowIndex].Rating = ratingValue;
    setFormData(formData);
  };

  const handleEditorChange = (id, data) => {

    formData.lines[id].Comment = data;
    if (data != "") {
      setCommentError((prev) => ({
        ...prev,
        [id]: "",
      }));
    }
    setFormData(formData);
  };

  const handleFile = async (file) => {
    if (file) {
      if (file.size < 5242880) {
        setFileName(file.name);
        setFile(file);
        setFormData((prevState) => ({
          ...prevState,
          file: file,
        }));
        setFileError("");
      } else {
        setFileError("File size should not be exceed than 5MB.");
      }
    }
  };

  // Handle change is here
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    let formValid = true;
    if (formData.CandiateStatus_181 == null) {
      formValid = false;
    }

    let sum = 0;
    let comment_error = [];
    for (let i = 0; i < formData.lines.length; i++) {
      if (formData.lines[i].Comment == "undefined") {
        comment_error[i] = `This field is required`;
        formValid = false;
      }
      sum += formData.lines[i].Rating;
    }
    setCommentError(comment_error);
    formData.OverallRating = Math.floor(sum / formData.lines.length);
    if (formValid) {
      try {
        formData.EligibleNextRound = selectedOption.toLowerCase() === "yes" ? 1 : 0;
        formData.SuitableForPosition = selectedOption;
        formData.CandiateStatus_181 = selectedOption.toLowerCase() === "yes" ? 1265 : 1266;
        const response = await PostFormServiceCaller(
          `${API_URL}interviewfeedback`,
          formData,
          "post"
        );
        toast.success("FeedBack Submitted Successfully");
        navigate("/feedback-submitted");
      } catch (error) {
        toast.error(
          "Feedback is not submitted. Issue From Backend, Must Connet to Team"
        );
      }finally {
        setLoading(false);
      }
    } else {
      toast.error("Specify candidate's next round status.");
      setLoading(false);
    }
  };

  const handleEditModalClose = () => {
    setShowEditModal(false);
  };

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Interview Form Feedback"));
  }, []);

  if (pageLoading) {
    return (
      <>
        <p class="position-absolute top-50 start-50 translate-middle text-center">
          <FaSpinner class="spinner" />
        </p>
      </>
    );
  } else {
    return (
      <div className="container-fluid" id="skill_section">
        <form id="formOne" className="rounded mt-2 bg-white">
          <table className="table table-bordered table-condensed table-responsive">
            <thead id="thcolor" className="text-center container-fluid">
              <tr className="text-center">
                <th>Interviewee</th>
                <th>Job Title</th>
                <th>Round</th>
                <th>JD</th>
                <th>Resume</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{basicDetail.interviewee}</td>
                <td>{basicDetail.JobTitle}</td>
                <td className="text-center">{formData.Round_name}</td>
                <td className="text-center">
                  {" "}
                  <p
                    className=" text-center text-primary pe-auto"
                    onClick={(e) => setShowEditModal(true)}
                  >
                    View JD
                  </p>
                </td>
                <td className="text-center">
                  <p className=" text-center word-wrap">
                    <a
                      target="_blank"
                      href={formData.ResumeBasePath}
                    >
                      View Resume
                    </a>
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
        </form>
        <form
          onSubmit={handleSubmit}
          id="formOne"
          className="rounded mt-4 bg-white"
        >
          <div className="row">
            <div className="box-body table-responsive container-fluid ">
              <Table striped bordered hover>
                <thead id="thcolor" className="text-center container-fluid">
                  <tr>
                    <td className="text-center">Sr.No.</td>
                    <td className="col-2">Feedback Category</td>
                    <td className="">Competency</td>
                    <td className="col-1">Rating out of 5</td>
                    <td className="col-4">Remark</td>
                  </tr>
                </thead>
                <tbody>
                  {skillEvaluationPara.map((parameter, index) => (
                    <tr key={index}>
                      <td className="text-center">{index + 1}</td>
                      <td>{parameter.GroupCategoryLabel}</td>
                      <td>
                        <HTMLComponent
                          html={parameter.GroupCategoryDescription}
                        />
                      </td>
                      <td className="text-center ">
                        <RatingInput
                          id={index}
                          onChange={(ratingValue) =>
                            handleRatingChange(index, ratingValue)
                          }
                        />
                      </td>
                      <td>
                        <div className="editor-section">
                          <MyEditor id={index} onChange={handleEditorChange} />
                          <span className="error">{commentError[index]}</span>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-6 container justify-content-center d-flex">
              <dt className="me-3">
                Consider Next Round <span className="required">*</span>
              </dt>
              <div className="d-flex mr-2">
                <div className="form-check me-2">
                  <input
                    type="radio"
                    className="form-check-input"
                    id="Yes"
                    name="roundresult"
                    value="Yes"
                    checked={selectedOption === "Yes"}
                    onChange={HandleResult}
                  />
                  <label className="form-check-label" htmlFor="Yes">
                    Yes
                  </label>
                </div>
                <div className="form-check">
                  <input
                    type="radio"
                    className="form-check-input"
                    id="No"
                    name="roundresult"
                    value="No"
                    checked={selectedOption === "No"}
                    onChange={HandleResult}
                  />
                  <label className="form-check-label" htmlFor="No">
                    No
                  </label>
                </div>
              </div>
            </div>
            {/* <div className="col-6 text-start">
            <div className="container  d-flex ">
              <dt className="mr-2  ">
                Image <span className="required">*</span>
              </dt>
              <div className="form-group d-flex ms-4  ">
                <label htmlFor="imageInput" style={{ cursor: "pointer" }}>
                  <img
                    className=""
                    src="https://t4.ftcdn.net/jpg/05/65/22/41/360_F_565224180_QNRiRQkf9Fw0dKRoZGwUknmmfk51SuSS.jpg"
                    alt="Upload"
                    style={{ width: "40px", height: "40px" }}
                  />
                  {selectedImage && (
                    <span>{truncateImageName(selectedImage, 20)}</span>
                  )}{" "}
                  
                </label>
                <input
                  type="file"
                  className="form-control-file"
                  id="imageInput"
                  accept="image/*"
                  onChange={handleImageChange}
                  style={{ display: "none" }}
                />

              </div>
            </div>
          </div> */}
            <div className="col-6 text-start ">
              <div className="container  d-flex ">
                <dt className="mr-4  ">
                  Image
                </dt>

                <div className="form-group d-flex ms-4  ">
                  <FileUploader handleFile={handleFile} Name={"Upload Img"} />
                  {fileName ? <p>{fileName}</p> : null}
                  {formData.resume && !fileName ? (
                    <p>{formData.resume}</p>
                  ) : null}
                  <br />
                </div>
                <span className="error">{fileError}</span>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="d-flex justify-content-end">
              <div className="me-2">
                <button JobType="submit" className="custom-btn" disabled={loading ? true : false}>
              {loading ? <FaSpinner class="sm-spinner" /> : "Submit"}
                </button>
              </div>
            </div>
          </div>
        </form>
        <Modal
          show={showEditModal}
          onHide={handleEditModalClose}
          className="custom-modal"
        >
          <Modal.Header closeButton className="p-3">
            <h5>
              <b>Job Description</b>
            </h5>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-12">
                <p>
                  <HTMLComponent html={jobDescription} />
                </p>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
};

export default AddFeedback;
